import React from 'react'
import { Tooltip } from 'antd'
import { useIntl } from 'react-intl'

import './styles.less'

import IntlMessages from '../../util/IntlMessages'

interface RightActionBarOnboardingProgressProps {
  currentStep: number
  totalSteps: number
  onClick?: () => void
}

export const RightActionBarOnboardingProgress: React.FC<RightActionBarOnboardingProgressProps> = ({
  currentStep,
  totalSteps,
  onClick,
}) => {
  const { formatMessage } = useIntl()

  // Calculate progress percentage for partial circle
  const progressPercentage = (currentStep / totalSteps) * 100

  // Hide when all steps are completed
  if (progressPercentage >= 100) {
    return null
  }

  // Use primary purple color for all onboarding types
  const getProgressColor = () => {
    return '#722ed1' // Purple (primary color) for all types
  }

  // Calculate stroke-dasharray for partial circle
  const radius = 12
  const circumference = 2 * Math.PI * radius
  const strokeDasharray = circumference
  const strokeDashoffset = circumference - (progressPercentage / 100) * circumference

  return (
    <div className="right-actionbar-onboarding-progress">
      <Tooltip
        placement="left"
        title={<IntlMessages id="onboarding.v2.progress.button" values={{ completed: currentStep, total: totalSteps }} />}
        className="right-actionbar-tooltip"
      >
        <div
          className="onboarding-progress-container"
          onClick={onClick}
          style={{
            cursor: onClick ? 'pointer' : 'default',
          }}
        >
          {/* Partial Circle Progress Indicator */}
          <div className="progress-circle-container">
            <svg width="32" height="32" className="progress-circle">
              {/* Background circle */}
              <circle
                cx="16"
                cy="16"
                r={radius}
                fill="none"
                stroke="#f0f0f0"
                strokeWidth="2"
              />
              {/* Progress circle */}
              <circle
                cx="16"
                cy="16"
                r={radius}
                fill="none"
                stroke={getProgressColor()}
                strokeWidth="2"
                strokeLinecap="round"
                strokeDasharray={strokeDasharray}
                strokeDashoffset={strokeDashoffset}
                transform="rotate(-90 16 16)"
                className="progress-circle-fill"
              />
            </svg>
            <div className="onboarding-step-number">
              {currentStep}
            </div>
          </div>

          <span className="right-actionbar-text">
            {formatMessage({ id: 'onboarding.rightActionBar.title' })}
          </span>
        </div>
      </Tooltip>
    </div>
  )
}
